import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import LogRocket from 'logrocket';
import { featureFlags } from './shared/config/featureFlags/featureFlags';
import { env } from './shared/config/env/env';

// after calling LogRocket.init()
if (featureFlags.logRocket) {
	const appId = env.LOGROCKET_APP_ID;
	if (appId) {
		LogRocket.init(appId);
	} else {
		console.warn('LogRocket enabled but VITE_LOGROCKET_APP_ID is not set');
	}
}
const root = ReactDOM.createRoot(
	document.getElementById('root') as HTMLElement
);
root.render(
	<BrowserRouter>
		<App/>
	</BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
